var map = {
	"./answer-icon.svg": "804d",
	"./class-manage-icon.svg": "d176",
	"./class-work-icon.svg": "ae16",
	"./close-icon.svg": "e761",
	"./comment-icon.svg": "9785",
	"./delete-icon.svg": "43f1",
	"./edit-icon.svg": "00bf",
	"./exit-icon.svg": "53a7",
	"./figure-icon.svg": "b184",
	"./fullscreen-icon.svg": "e1f0",
	"./gather-icon.svg": "bef6",
	"./history-comment-icon.svg": "e8e4",
	"./horologe-icon.svg": "6244",
	"./ipad-center-1.svg": "5377",
	"./ipad-center-2.svg": "3263",
	"./ipad-center-3.svg": "6282",
	"./ipad-center-4.svg": "906e",
	"./ipad-center-5.svg": "5e33",
	"./left-point.svg": "9b13",
	"./null-photo.svg": "84a3",
	"./open-icon.svg": "0b9d",
	"./photo-icon.svg": "ad26",
	"./photograph-icon.svg": "0a111",
	"./play-icon.svg": "216a",
	"./point-icon.svg": "a883",
	"./point2-icon.svg": "307d",
	"./pro-icon.svg": "71f8",
	"./share-icon.svg": "3629",
	"./small-tools-icon.svg": "e31c",
	"./student-manage-icon.svg": "1b34",
	"./study-icon.svg": "4e27",
	"./tools-icon.svg": "6552",
	"./video-icon.svg": "459b",
	"./work-gather-icon.svg": "d060",
	"./work-icon.svg": "8295",
	"./works-all-icon.svg": "8427"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";